/**
 * @file Fab atom — floating action button family.
 * @description structured atom: compound parts re-exported from the vendored
 * Gluestack family; this is the only sanctioned import path for app code
 * (RFC §3).
 * @module components/atoms/Fab
 */
export { Fab, FabLabel, FabIcon } from "@/components/ui/fab";
